import { render, staticRenderFns } from "./AccountVerificationResend.vue?vue&type=template&id=75eb3597&"
import script from "./AccountVerificationResend.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationResend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports